import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pl from 'vuetify/lib/locale/pl';
import en from 'vuetify/lib/locale/en';

Vue.use(Vuetify);

const savedLocale = (typeof localStorage !== 'undefined' && localStorage.getItem('adminLocale')) || 'pl';

export default new Vuetify({
  lang: {
    locales: { pl, en },
    current: savedLocale,
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: '#3F51B5',
        secondary: '#1A2433',
        accent: '#42A5F5',
        error: '#F44336',
        warning: '#FF9800',
        info: '#00BCD4',
        success: '#4CAF50',
        anchor: '#42A5F5',
        background: '#0F1923',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
